import forOwn from 'mout/object/forOwn'

export default function getSubjectThresholdData (threshold, thresholdBreaks) {
  let data = {}
  forOwn(threshold, (counts, subject) => {
    if (subject !== 'composite') {
      let subjectData = []
      let i = 1
      thresholdBreaks.forEach((breakpoint, n) => {
        if (n + 1 === thresholdBreaks.length) {
          const min = parseInt(i, 10)
          let count = 0
          while (i <= 36) {
            if (counts[i]) {
              count += counts[i]
            }
            i++
          }
          subjectData.push(
            {min, max: 36, count }
          )
        } else {
          const min = parseInt(i, 10)
          let count = 0
          while (i <= breakpoint) {
            if (counts[i]) {
              count += counts[i]
            }
            i++
          }
          subjectData.push(
            {min, max: i - 1, count }
          )
        }
      })
      data[subject] = subjectData
    }
  })
  return data
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getSubjectThresholdData.js